import { inject, Injectable } from "@angular/core";
import { TranslationService } from "@app/kernel/translations/translation.service";
import { InterpolationParameters } from "@ngx-translate/core";
import { MessageService } from "primeng/api";

@Injectable()
export class ToastService {
  private messageService = inject(MessageService);
  private translationService = inject(TranslationService);

  /**
   * Shows a success message
   * @param message
   * @param summary
   */
  success(
    message: string,
    summary = "Success",
    options?: { summaryTranslationValue?: InterpolationParameters; detailTranslationValue?: InterpolationParameters }
  ) {
    this.messageService.add({
      severity: "success",
      summary: this.translationService.instant(summary, options?.summaryTranslationValue),
      detail: this.translationService.instant(message, options?.detailTranslationValue),
    });
  }

  /**
   * Shows an info message
   * @param message
   * @param summary
   */
  info(
    message: string,
    summary = "Info",
    options?: { summaryTranslationValue?: InterpolationParameters; detailTranslationValue?: InterpolationParameters }
  ) {
    this.messageService.add({
      severity: "info",
      summary: this.translationService.instant(summary, options?.summaryTranslationValue),
      detail: this.translationService.instant(message, options?.detailTranslationValue),
    });
  }

  /**
   * Shows a warning message
   * @param message
   * @param summary
   */
  warn(
    message: string,
    summary = "Warn",
    options?: { summaryTranslationValue?: InterpolationParameters; detailTranslationValue?: InterpolationParameters }
  ) {
    this.messageService.add({
      severity: "warn",
      summary: this.translationService.instant(summary, options?.summaryTranslationValue),
      detail: this.translationService.instant(message, options?.detailTranslationValue),
    });
  }

  /**
   * Shows an error message
   * @param message
   * @param summary
   */
  error(
    message: string,
    summary = "Error",
    options?: { summaryTranslationValue?: InterpolationParameters; detailTranslationValue?: InterpolationParameters }
  ) {
    this.messageService.add({
      severity: "error",
      summary: this.translationService.instant(summary, options?.summaryTranslationValue),
      detail: this.translationService.instant(message, options?.detailTranslationValue),
    });
  }

  snackbar(message: string, btns?: { class: string; text: string; onClick: (closeFn: () => void) => void }[], sticky = true) {
    this.messageService.add({
      key: "snackbar",
      severity: "custom",
      styleClass: "toast-snackbar",
      detail: message,
      data: { btns },
      sticky,
    });
  }

  /**
   * Clears all messages
   */
  clear(key?: string) {
    this.messageService.clear(key);
  }
}
